import { render } from "./Role.vue?vue&type=template&id=7683d5d6&scoped=true"
import script from "./Role.vue?vue&type=script&lang=ts"
export * from "./Role.vue?vue&type=script&lang=ts"

import "./Role.vue?vue&type=style&index=0&id=7683d5d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7683d5d6"

export default script